import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { type EdgeProps, useReactFlow } from '@xyflow/react';
import { useId, useState } from 'react';

import { isTruthy } from 'common';

import { type ReactFlowStickyNoteNode } from '../../../../../types';
import { FLOW_DECORATION_COLORS, FlowDecorationColor } from '../constants';

function DecorationsColorIcon(props: { color: FlowDecorationColor }) {
  const { color } = props;
  return (
    <Box
      sx={{
        width: 20,
        height: 20,
        borderRadius: '50%',
        ...FLOW_DECORATION_COLORS[color],
        borderWidth: '1px',
        borderStyle: 'solid',
      }}
    />
  );
}

interface DecorationColorMenuProps {
  nodeId: string;
  color: FlowDecorationColor;
}

export function DecorationColorMenu(props: DecorationColorMenuProps) {
  const { nodeId, color } = props;
  const { updateNodeData } = useReactFlow<ReactFlowStickyNoteNode, EdgeProps>();
  const menuButtonId = useId();
  const [colorMenuAnchorElement, setColorMenuAnchorElement] = useState<HTMLElement | null>(null);
  const menuIsOpen = isTruthy(colorMenuAnchorElement);
  return (
    <>
      <IconButton
        id={menuButtonId}
        aria-haspopup="true"
        aria-expanded={menuIsOpen ? 'true' : undefined}
        aria-label="Pick color"
        size="small"
        onClick={(event) => {
          setColorMenuAnchorElement(event.currentTarget);
        }}
      >
        <DecorationsColorIcon color={color} />
      </IconButton>
      <Menu
        aria-labelledby={menuButtonId}
        open={menuIsOpen}
        onClose={() => setColorMenuAnchorElement(null)}
        anchorEl={colorMenuAnchorElement}
      >
        {Object.values(FlowDecorationColor).map((color) => {
          return (
            <MenuItem
              key={color}
              value={color}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onClick={() => {
                updateNodeData(nodeId, {
                  color,
                });
                setColorMenuAnchorElement(null);
              }}
            >
              <DecorationsColorIcon color={color} />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
